// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { QbItemServiceDto } from './QbItemServiceDto';
import { CaseTypeDto } from './CaseTypeDto';
import { QbCustomerDto } from './QbCustomerDto';
import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.CompanyDto
export class CompanyDto extends EntityBaseDto {
    public name: string = null;
    public contactName: string = null;
    public contactPhone: string = null;
    public did: string = null;
    public dialoutPrefix: string = null;
    public notes: string = null;
    public newCustomersRequireApproval: boolean = false;
    public isActive: boolean = false;
    public serviceItem: QbItemServiceDto = null;
    public caseTypes: CaseTypeDto[] = [];
    public customer: QbCustomerDto = null;
}


    



